export default __webpack_public_path__ + "static/media/10.5ec3b06c.jpg";